<template>
  <div style="width: 100%; text-align:right;">
    <div class="scrollContent">
      <v-layout row wrap style="padding: 10px;">
        <v-flex xs3>
          Key
        </v-flex>
        <v-flex xs3>
          Date
        </v-flex>
        <v-flex xs3>
          Weather
        </v-flex>
        <v-flex xs3>
          Diary
        </v-flex>
      </v-layout>
      <v-layout row wrap style="padding: 20px; margin: 20px; background-color: #eee;" v-for="page in diaryPages">
        <v-flex xs3>
          {{page.Date}}
        </v-flex>
        <v-flex xs3>
          {{page['.key']}}
        </v-flex>
        <v-flex xs3>
          {{page.Weather}}
        </v-flex>
        <v-flex xs3>
          <span class="custom-dropdown custom-dropdown--white" style="float: right;">
            <select v-model="page.selectedDiaryKey" @change="pageSelected(page)" class="custom-dropdown__select custom-dropdown__select--white">
              <option v-for="diary in diaries" :value="diary['.key']">{{diary.Title}}</option>
            </select>
          </span>
          <input type="button" value="Delete" @click="deletePage(page)" />
        </v-flex>
        <v-layout row wrap v-for="note in getNotesArr(page)" style="padding: 20px; margin: 20px; width: 100%; background-color: #aaa;">
          <v-flex xs3>
            {{note.Time}}
          </v-flex>
          <v-flex xs3>
            {{note.UserFullName}}-{{note.UserType}}
          </v-flex>
          <v-flex xs4>
            {{note.Info}}
          </v-flex>
          <v-flex xs2>
            <input type="button" value="Delete" @click="deleteNote(page, note)" />
          </v-flex>
        </v-layout>
      </v-layout>
      <!--<div v-for="page in diaryPages" style="direction: rtl;padding: 20px; margin: 20px; background-color: #ccc;">
        {{page['.key']}} - {{page.Date}} - {{page.Weather}}
      </div>-->
    </div>
  </div>
</template>

<script>
  import { db } from '../firebase';
  var diariesRef = db.ref('Diaries');
  var diaryPagesRef = db.ref('DiaryPages');

  export default {
    name: 'ReportDiaries',
    data() {
      return {
        diaries: [],
        diaryPages: []
      }
    },
    firebase: function () {
      var vm = this;
      return {
        diaries: diariesRef.orderByKey(),
        diaryPages: diaryPagesRef.orderByKey()
      }
    },
    computed: {
    },
    created() {
      this.$Log("Vue [ReportDiaries] is created ...");
    },
    ready() {
      this.$Log("Vue [ReportDiaries] is ready ...");
    },
    mounted() {
      this.$Log("Vue [ReportDiaries] is mounted ...");
    },
    updated() {
      this.$Log("Vue [ReportDiaries] is updated ...");
    },
    methods: {
      getNotesArr(page) {
        var notes = [];
        if (page && page.Notes) {
          var keys = Object.keys(page.Notes);
          for (var i = 0; i < keys.length; i++) {
            var k = keys[i];
            var note = page.Notes[k];
            note['.key'] = k;
            notes.push(note);
          }
        }

        return notes;
      },
      pageSelected(page) {
        //page.selectedDiaryKey

        var pageObj = {
          Date: page.Date,
          PageKey: page['.key']
        }

        var diaryRef = db.ref('Diaries/' + page.selectedDiaryKey + '/Pages');
        alert('Diaries/' + page.selectedDiaryKey + '/Pages');
        alert(JSON.stringify(pageObj));
        
        diaryRef.push(pageObj);
      },
      deleteNote(page, note) {
        //alert(JSON.stringify(note))
        //alert(note['.key'])
        var noteRef = db.ref('DiaryPages/' + page['.key'] + '/Notes/' + note['.key']);
        //alert('DiaryPages/' + page['.key'] + '/Notes/' + note['.key'])
        noteRef.remove();
      },
      deletePage(page) {
        var diaryPageRef = db.ref('DiaryPages/' + page['.key']);
        //alert('DiaryPages/' + page['.key'])
        diaryPageRef.remove();
      }
    }
  }

</script>
<style>
</style>



// WEBPACK FOOTER //
// ReportDiaries.vue?20f88edf